import { Button, Card, Form, Input, Typography, message } from 'antd';
import React from 'react';
import { useNavigate, useParams } from 'react-router';
import { apiFormsGet, apiFormsUpdate } from '../../services/api/forms';
import { useSelector } from 'react-redux';
import { selectUserState } from '../../store/selectors/user';
import {
  ApiFormsGetResponse,
  ApiFormsUpdateRequestBody,
} from '../../services/api/types/forms';
import { PlusOutlined, MinusCircleOutlined } from '@ant-design/icons';

interface FormEmailsState {
  emails: string[];
}

function FormNotificationEmailsEditPage() {
  const { token } = useSelector(selectUserState);
  const { formId } = useParams();
  const navigate = useNavigate();
  const [responseGetForm, setResponseGetForm] =
    React.useState<ApiFormsGetResponse | null>(null);
  const [formNotificationEmailsForm] = Form.useForm<FormEmailsState>();

  async function loadFormData(tk: string, fid: number) {
    const [response, status] = await apiFormsGet(tk, fid);
    if (status === 200) {
      setResponseGetForm(response);
      formNotificationEmailsForm.setFieldValue(
        'emails',
        response.data.notificationEmails?.map((or) => or.notificationEmail),
      );
    } else {
      message.error({ content: 'Error loading form!' });
      navigate('/');
    }
  }

  React.useEffect(() => {
    if (token && formId) {
      loadFormData(token, parseInt(formId, 10));
    }
  }, [token, formId]);

  const formEmailsSubmit = React.useCallback(
    async (values: FormEmailsState) => {
      if (responseGetForm && token && values && Object.keys(values).length) {
        const updateFormRequestBody: ApiFormsUpdateRequestBody = {
          formId: responseGetForm.data.id,
          emails: values.emails,
        };
        const [response, status] = await apiFormsUpdate(
          token,
          updateFormRequestBody,
        );
        if (status === 200) {
          message.success({ content: 'Form updated successfully!' });
          loadFormData(token, response.data.id);
        } else {
          message.error({ content: 'Failed form update!' });
        }
      }
    },
    [token, responseGetForm],
  );

  if (!formId) {
    message.error('Missing formId in url!');
    navigate('/');
    return null;
  }

  return (
    <Card bordered={false} title="Single Form">
      <Typography.Title level={2}>Form Emails Edit</Typography.Title>
      <Form form={formNotificationEmailsForm} onFinish={formEmailsSubmit}>
        <Form.List name="emails">
          {(fields, { add, remove }, { errors }) => (
            <>
              {fields.map((field, index) => (
                <Form.Item required={false} key={field.key}>
                  <Form.Item
                    {...field}
                    validateTrigger={['onChange', 'onBlur']}
                    rules={[
                      {
                        required: true,
                        whitespace: true,
                        message: 'Please input notification email',
                      },
                    ]}
                    noStyle
                  >
                    <Input
                      placeholder="example@tapform.io"
                      style={{ width: '60%' }}
                    />
                  </Form.Item>
                  <MinusCircleOutlined
                    className="dynamic-delete-button"
                    onClick={() => {
                      remove(field.name);
                    }}
                    style={{ height: 50, marginLeft: 20, fontSize: 20 }}
                  />
                </Form.Item>
              ))}
              <Button
                type="dashed"
                onClick={() => {
                  add();
                }}
                icon={<PlusOutlined />}
              >
                Add email
              </Button>
            </>
          )}
        </Form.List>
        <Form.Item>
          <Button type="primary" htmlType="submit" style={{ marginTop: 55 }}>
            Update Emails
          </Button>
        </Form.Item>
      </Form>
    </Card>
  );
}

export default FormNotificationEmailsEditPage;
